<template>
  <div class="SpTradesTab">
    <new-trade v-if="isNewTrade" />
    <programs-trade v-else-if="!isEditTrade && Programs.length" />
    <program-empty v-else-if="!isEditTrade && !Programs.length" icon="/img/emptyIconProgram.png" />
    <edit-trade v-else />
  </div>
</template>

<script>
import NewTrade from "./program/NewTrade";
import EditTrade from "./program/EditTrade";
import ProgramsTrade from "./program/ProgramsTrade";
import ProgramEmpty from "./program/ProgramEmpty";

export default {
  name: "SpTradesTab",
  components: {ProgramEmpty, ProgramsTrade, EditTrade, NewTrade},
  computed: {
    currentProgram() {
      return this.$store.state.currentProgram;
    },
    isNewTrade: {
      get() {
        return this.$store.state.isNewTrade;
      },
      set(value) {
        this.$store.commit('setter', {isNewTrade: value})
      }
    },
    isEditTrade: {
      get() {
        return this.$store.state.isEditTrade;
      },
      set(value) {
        this.$store.commit('setter', {isEditTrade: value})
      }
    },
    Programs() {
      return this.$store.state.programs;
    }
  },
  mounted() {
    this.isEditTrade = false;
    this.isNewTrade = false;
    this.getPrograms();
  },
};
</script>

<style lang="scss">
@import "assets/styles/components/variables";

.button-holder {
  .back {
    display: flex;
    align-items: center;
    border: none;
    padding: 0;
    outline: none;
    color: $magenta-1;
    background: none;
    cursor: pointer;
    font-size: 16px;
  }
}

.SpTradesTab {
  .dark-arrow {
    display: none;
  }

  .light-arrow {
    display: inline-block;
  }

  .long-arrow {
    margin-right: 4px;
  }

  #pagination {
    margin-top: 30px;

    ul {
      justify-content: center;
    }
  }

  .button-holder {
    text-align: right;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;

    .btn {
      font-size: 14px;
      color: $magenta-1;
      font-weight: 500;

      &:focus,
      &:active,
      &:visited,
      &:focus-within,
      &:focus-visible,
      &:visited {
        border: 1px solid $magenta-1;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        border-radius: 20px;

        &:after {
          display: none;
        }
      }
    }
  }

  .table-wrapperNew {
    padding: 0 0 10px;

    .main-tab {
      border-bottom: 10px solid;
      border-bottom-color: #fff;
    }
  }

  table {
    width: 100%;
    padding: 14px 7px 0 13px;

    td {
      padding-bottom: 10px;
    }

    .id-num {
      cursor: pointer;
      font-size: 16px;
      color: $magenta-1;
      padding-right: 3px;
    }

    .btcusd {
      font-size: 18px;
      font-weight: 500;
      color: $dark-purple;
      padding-right: 5px;
    }

    .text-1 {
      font-size: 12px;
      color: $legend;
      padding-right: 5px;
    }

    .text-2 {
      font-size: 16px;
      color: $dark-purple;
      padding-right: 5px;
    }

    .text-3 {
      font-size: 14px;
      color: $legend;
    }

    .date {
      padding: 0 3px 10px;
    }
  }
}
</style>
